import React from 'react';

import createSvgIcon from './hoc/createSvgIcon';

export default createSvgIcon(
  () => (
    <>
      <svg id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
        <path
          fill="#0A46BA"
          d="M39.4 49h-15c-6.8 0-8.6-6-7.6-10 .7-3.2 3.2-4.5 6-5 1-.2 1.5-.6 1.7-1.7 1-4 3-6.8 7.2-7.7 4-1 7.6 0 10.3 3.4.4.6.8.7 1.5.4 4.6-1.7 9.4.2 11 4.3l.6 2.8c.4.6.5 1 1 1 5 1.7 5 7.5 3 10.5-1 1.5-2.5 2-4.3 2H39.4z"
        />
        <path
          fill="#0A46BA"
          d="M10.2 31c0-8.8 7.6-13 14-9.6 3.4-5.2 8-7.5 14.3-5.6 5 1.5 7.6 5 8.6 10l-3.2.8c-.2 0-.6 0-.8-.3-7-6.8-17.2-4.3-20 4.7-.3.8-.6 1.2-1.5 1.5-3.5 1-6 3-7 7-.4 2.3 0 4.7 1.4 7-3.4 0-6 .7-9-1-3-1.8-4-4.8-3.7-8.2.6-3.3 2.6-5.3 6-6l1-.3z"
        />
      </svg>
    </>
  ),
  'OneDrive',
  '0 0 120 120'
);
